import React from 'react';
import { Wifi, WifiOff, RefreshCw, Cloud, CloudOff } from 'lucide-react';

interface SyncStatusProps {
  isOnline: boolean;
  pendingCount: number;
  isSyncing: boolean;
  onManualSync: () => void;
}

export function SyncStatus({ isOnline, pendingCount, isSyncing, onManualSync }: SyncStatusProps) {
  if (!isOnline) {
    return (
      <div className="flex items-center gap-1.5 px-2 py-1.5 bg-orange-50 border border-orange-200 rounded-lg shadow-md">
        <WifiOff className="w-3.5 h-3.5 text-orange-600 flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <span className="text-xs text-orange-800 font-medium block leading-tight">Offline</span>
          {pendingCount > 0 && (
            <p className="text-[10px] text-orange-600 leading-tight">
              {pendingCount} saved
            </p>
          )}
        </div>
      </div>
    );
  }

  if (isSyncing) {
    return (
      <div className="flex items-center gap-1.5 px-2 py-1.5 bg-blue-50 border border-blue-200 rounded-lg shadow-md">
        <RefreshCw className="w-3.5 h-3.5 text-blue-600 animate-spin flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <span className="text-xs text-blue-800 font-medium block leading-tight">Syncing</span>
          {pendingCount > 0 && (
            <p className="text-[10px] text-blue-600 leading-tight">
              {pendingCount} left
            </p>
          )}
        </div>
      </div>
    );
  }

  if (pendingCount > 0) {
    return (
      <div className="flex flex-col gap-1 px-2 py-1.5 bg-yellow-50 border border-yellow-200 rounded-lg shadow-md">
        <div className="flex items-center gap-1.5">
          <Wifi className="w-3.5 h-3.5 text-yellow-600 flex-shrink-0" />
          <span className="text-xs text-yellow-800 font-medium leading-tight">
            {pendingCount} pending
          </span>
        </div>
        <button
          onClick={onManualSync}
          className="w-full px-1.5 py-0.5 bg-yellow-600 text-white text-[10px] rounded hover:bg-yellow-700 transition-colors flex items-center justify-center gap-1"
        >
          <RefreshCw className="w-2.5 h-2.5" />
          Sync
        </button>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1.5 px-2 py-1.5 bg-green-50 border border-green-200 rounded-lg shadow-md">
      <Wifi className="w-3.5 h-3.5 text-green-600 flex-shrink-0" />
      <span className="text-xs text-green-800 font-medium leading-tight">Online</span>
    </div>
  );
}
